/**
 * Fire a tracking pixel. Uses `navigator.sendBeacon` when available, falls
 * back to a hidden Image. Fire-and-forget — never throws to the caller.
 */
export function fireBeacon(url: string): void {
  if (!url) return;
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(url);
      return;
    }
  } catch {
    // navigator.sendBeacon can throw on some opaque-response URLs; fall through.
  }
  try {
    const img = new Image(1, 1);
    img.referrerPolicy = 'no-referrer-when-downgrade';
    img.src = url;
  } catch {
    /* swallow */
  }
}
